<template>
  <e-modal
    :visible="visible"
    title="上传资源管理"
    :width="1000"
    @close="onClose"
    @ok="onSubmit"
  >
    <template #footer>
      <div class="buttons">
        <div>
          <a-input
            v-model:value="queryParams.Name"
            placeholder="文件名"
            allowClear
            style="width: 150px; margin-right: 8px"
          />

          <a-date-picker
            v-model:value="queryParams.Date"
            placeholder="上传日期"
          />
          <a-button type="primary" @click="getList()"> 搜索 </a-button>

          <a-button type="primary" @click="$refs.cropperImage.open()">
            <ScissorOutlined /> 裁剪上传
          </a-button>

          <a-upload
            name="file"
            :customRequest="uploads"
            multiple
            :beforeUpload="beforeUpload"
            :showUploadList="false"
            style="margin-right: 8px"
          >
            <a-button type="primary"> <UploadOutlined /> 文件上传 </a-button>
          </a-upload>

          <a-button type="primary" @click="$refs.shotImage.open()">
            <ScissorOutlined /> 截图上传
          </a-button>
        </div>

        <div>
          <a-button
            type="primary"
            :disabled="choosed.length === 0"
            @click="onSubmit"
          >
            选择
          </a-button>
          <a-button @click="onClose">关闭</a-button>
        </div>
      </div>
    </template>
    <div class="resource-body">
      <div class="right">
        <div class="rc-list">
          <a-spin tip="加载中..." :spinning="loading">
            <div class="list">
              <div
                v-for="(v, k) in list"
                :key="k"
                :class="{
                  item: true,
                  on: onCheckChoose(v.url),
                }"
                @click="onChoose(v.url)"
              >
                <div class="li">
                  <div class="li-img">
                    <img :src="v.url" alt="v.title" />
                  </div>
                  <div class="li-title">{{ v.name }}</div>
                </div>
              </div>
            </div>
          </a-spin>
        </div>

        <div class="page">
          <a-pagination
            :total="page.total"
            v-model:current="page.current"
            v-model:page-size="queryParams.Limit"
            :hide-on-single-page="true"
            :show-size-changer="true"
            :page-size-options="['20', '40', '100', '200']"
            @change="onChangePage"
            @showSizeChange="onSizeChange"
          >
            <template #itemRender="{ page, type }">
              <a v-if="type === 'prev'" class="ant-pagination-item-link">
                上一页
              </a>
              <a v-else-if="type === 'next'" class="ant-pagination-item-link">
                下一页
              </a>
              <span v-else>{{ page }}</span>
            </template>
          </a-pagination>
        </div>
      </div>
    </div>

    <CropperImage ref="cropperImage" @ok="uploadCropImage" />
    <ShotImage ref="shotImage" @ok="uploadCropImage" />
  </e-modal>
</template>

<script>
import { defineComponent, ref, toRaw } from 'vue'
import { UploadOutlined, ScissorOutlined } from '@ant-design/icons-vue'

import store from '@/store'
import defaultConfig from '@/config/default.config'
import { RcClass } from '@/apis/rc'
import CropperImage from './CropperImage'
import ShotImage from './ShotImage'

const api = new RcClass()
export default defineComponent({
  emits: ['ok'],
  components: {
    UploadOutlined,
    ScissorOutlined,
    CropperImage,
    ShotImage
  },
  setup (props, { emit }) {
    const projectId =
      Number(store.state.user.projectId) || Number(defaultConfig.project_token)

    const loading = ref(false)
    const visible = ref(false)

    const image = ref('')
    const number = ref(5)
    const field = ref('')
    const list = ref([])
    const choosed = ref([])

    const replaceFields = {
      key: 'id',
      title: 'name'
    }
    const page = ref({
      current: 1,
      total: 0
    })

    const queryParams = ref({
      Limit: 24,
      ProjectId: projectId
    })

    const onClose = () => {
      choosed.value = []
      visible.value = false
    }

    const onChoose = (image) => {
      const s = new Set(choosed.value)
      if (s.has(image)) {
        s.delete(image)
      } else {
        s.add(image)
      }
      choosed.value = Array.from(s)
    }

    const onCheckChoose = (image) => {
      return choosed.value.includes(image)
    }

    const getList = (index) => {
      page.value.current = index + 1
      loading.value = true
      const q = { ...toRaw(queryParams.value) }
      q.Offset = index
      q.Type = 0

      if (q.Date) {
        q.Date = q.Date.format()
      }

      api.gets(q).then((resp) => {
        list.value = resp.data
        page.value.total = resp.total
        loading.value = false
      })
    }

    const onChangePage = (e) => {
      getList(e - 1)
    }

    const onSizeChange = (cur, limit) => {
      queryParams.value.Limit = limit
      getList(cur)
    }

    return {
      visible,
      loading,
      list,
      choosed,
      image,
      page,
      queryParams,
      replaceFields,
      number,
      field,
      projectId,
      onClose,
      onChoose,
      onCheckChoose,
      getList,
      onChangePage,
      onSizeChange
    }
  },

  data () {
    return {
      uploadFileList: [],
      fileCount: 0
    }
  },

  methods: {
    open (number = 0, field = '') {
      this.field = field
      this.number = number
      this.getList(0)
      this.visible = true
    },

    onSubmit () {
      if (this.number > 0 && this.number < this.choosed.length) {
        this.$message.error(`最多选择${this.number}个文件`)
        return
      }
      this.$emit('ok', {
        images: toRaw(this.choosed),
        field: this.field
      })
      this.onClose()
    },

    beforeUpload (file, fileList) {
      this.fileCount = fileList.length
    },
    uploads (e) {
      this.loading = true
      const formData = new FormData()
      formData.append('file', e.file, e.file.name)
      formData.append('projectId', Number(this.projectId))
      api.add(formData).then((resp) => {
        this.uploadFileList.push(resp.url)
        if (this.uploadFileList.length >= this.fileCount) {
          this.uploadFileList = []
          this.fileCount = 0
          this.getList(0)
        }
      })
    },

    uploadCropImage (e) {
      e.append('projectId', Number(this.projectId))

      api.add(e).then(() => {
        this.$refs.cropperImage.onClose()
        this.$refs.shotImage.onClose()
        this.getList(0)
      })
    }
  }
})
</script>

<style lang="less" scoped>
.resource-body {
  position: relative;
  width: 100%;
  height: 570px;
  box-sizing: border-box;
  overflow: auto;
  .right {
    width: 100%;
    height: 100%;
    position: relative;
    padding-bottom: 50px;
    box-sizing: border-box;
    .rc-list {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;

      .list {
        width: 960px;
        display: flex;
        flex-wrap: wrap;
        .item {
          padding: 5px;
          box-sizing: border-box;
          width: 160px;
          cursor: pointer;
          .li {
            border: 1px solid transparent;
            padding: 5px;
            box-sizing: border-box;
            .li-img {
              display: flex;
              justify-content: center;
              align-items: flex-end;
              width: 100%;
              height: 114px;

              img {
                display: block;
                max-width: 100%;
                max-height: 100%;
              }
            }

            .li-title {
              font-size: 12px;
              line-height: 24px;
              text-align: center;
              overflow: hidden;
              height: 24px;
            }
          }

          &:hover {
            .li {
              border-color: #7e70ff;
              background: url(../assets/drag-bg-1.png);
            }
          }
          &.on {
            .li {
              border-color: #4c38ff;
              background: url(../assets/drag-bg.png);
            }
          }
        }
      }
    }
    .page {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
    }
  }
}
.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  button {
    margin: 0 5px;
  }
}
</style>
